module.exports = __webpack_public_path__ + "media/Footprints/Appliances-8469ad67.svg";